import React, { memo, forwardRef } from "react";
const SvgCapitalDelta = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M20.6 22.288L15.392 9.64l-5.016 12.648H20.6zM16.952 8.224l5.856 13.968c.16.4.24.72.24.96 0 .272-.096.528-.288.768-.192.24-.544.36-1.056.36H9.344c-.512 0-.864-.12-1.056-.36A1.209 1.209 0 018 23.152c0-.24.08-.56.24-.96l5.664-13.968C14.224 7.408 14.736 7 15.44 7c.704 0 1.208.408 1.512 1.224z"
      />
    </svg>
  );
});
SvgCapitalDelta.displayName = "SvgCapitalDelta";
const MemoForwardRef = memo(SvgCapitalDelta);
export default MemoForwardRef;
